<template>
  <el-container style="width:100%;">
    <el-main v-loading="loading">
      <el-card class="box-card">
        <h3>{{ generateCustomizeString('emailNotificationSettings') }}</h3>
        {{ generateCustomizeString('selectEmailNotificationRecipients') }}
        <br /><br />
        <el-checkbox-group v-model="selected">
          <el-checkbox v-for="(candidate, index) in candidates" :key="index" :label="candidate"></el-checkbox>
        </el-checkbox-group>
        <br />
        <el-button @click="setRecipients">{{generateCustomizeString('submit')}}</el-button>
      </el-card>
    </el-main>
  </el-container>
</template>

<script>
import { generateCustomizeString } from '@/utils/i18n'
import request from '@/utils/request'

export default {
  name: 'NotificationManagement',
  data() {
    return {
      loading: false,
      selected: [],
      candidates: []
    }
  },
  created() {
    this.getSettings()
  },
  methods: {
    generateCustomizeString,
    getSettings: function() {
      this.loading = true
      request({
        url: 'email/notification/recipients/get',
        method: 'get'
      })
        .then(res => {
          if (res.status === 0) {
            this.selected = res.data.selected
            this.candidates = res.data.candidates
          } else {
            this.$message.fail(this.generateCustomizeString('dataError'))
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    setRecipients: function() {
      request({
        url: 'email/notification/recipients/set',
        method: 'post',
        data: { 'selected': this.selected }
      })
        .then(res => {
          if (res.status === 0) {
            this.$message.success(this.generateCustomizeString('successUpdated'))
          } else {
            this.$message.fail(this.generateCustomizeString('updateFailed'))
          }
        })
    }
  }
}
</script>
<style lang="less" scoped>
</style>
